import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { borrowingQuotaShape } from '@bibliocommons/bc-prop-types';
import { Link, withRouter } from 'react-router';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { getTotalCountFromSummary, getTotalFromMaterialTypeCounts } from '@bibliocommons/utils-borrowing';

import HoldStatusIcon from '../HoldStatusIcon';
import BorrowingStatus from '../../shared/BorrowingStatus';
import SidebarCompactTitle from '../../sidebar/SidebarCompactTitle';
import HoldsSidebarLink from '../HoldsSidebarLink';
import AllSidebarLink from '../../sidebar/AllSidebarLink';

import './HoldsStatus.scss';

const STATUS_ORDER = ['SUSPENDED', 'NOT_YET_AVAILABLE', 'IN_TRANSIT', 'READY_FOR_PICKUP'];

export class HoldsStatus extends BcReactComponent {
  renderAllItemsButton() {
    const statusSummaries = this.props.summary.get('status', Immutable.Map());
    if (statusSummaries.size > 1) {
      return (
        <AllSidebarLink to="/v2/holds" selected={this.noStatusIsSelected()} />
      );
    }

    return null;
  }

  getTotalCount() {
    return getTotalCountFromSummary(this.props.summary);
  }

  statusIsActive(status) {
    return this.props.router.location.pathname.includes(`v2/holds/${status.toLowerCase()}`);
  }

  noStatusIsSelected() {
    return this.props.router.location.pathname === '/v2/holds';
  }

  renderGrouping(status) {
    return (
      <HoldsSidebarLink
        key={status}
        status={status}
        selected={this.statusIsActive(status)}
        summary={this.props.summary} />
    );
  }

  renderRemainingHolds() {
    if (this.props.summary.get('quotas')) {
      if (this.props.ILSQuotas) {
        return (
          <div className="free-holds-remaining">
            <span className="free-holds-text">
              <FormattedMessage id="free_holds_remaining" />
            </span>
            <span className="pull-right free-holds-count">
              {this.props.ILSQuotas.get('remaining')} / {this.props.ILSQuotas.get('total')}
            </span>
          </div>
        );
      }
    }
    return null;
  }

  renderReadyForPickupSummary() {
    const statusSummaries = this.props.summary.get('status', Immutable.Map());
    return statusSummaries.get('READY_FOR_PICKUP') && (
      <span className="ready_for_pickup status-label">
        <div className="hold-status-icon status-icon">
          <HoldStatusIcon status="READY_FOR_PICKUP" />
        </div>
        {getTotalFromMaterialTypeCounts(statusSummaries.get('READY_FOR_PICKUP'))}
      </span>
    );
  }

  renderInTransitSummary() {
    const statusSummaries = this.props.summary.get('status', Immutable.Map());
    return statusSummaries.get('IN_TRANSIT') && (
      <span className="in_transit status-label">
        <div className="hold-status-icon status-icon">
          <HoldStatusIcon status="IN_TRANSIT" />
        </div>
        {getTotalFromMaterialTypeCounts(statusSummaries.get('IN_TRANSIT'))}
      </span>
    );
  }

  renderCompactStatus() {
    const readyForPickupSummary = this.renderReadyForPickupSummary();
    const inTransitSummary = this.renderInTransitSummary();

    return (
      <span>
        <SidebarCompactTitle
          title={<FormattedMessage id="section_title_holds" />}
          count={this.getTotalCount()} />

        {(readyForPickupSummary || inTransitSummary) && (
          <div className="small hold-status">
            {readyForPickupSummary}
            {inTransitSummary}
          </div>
        )}
      </span>
    );
  }

  renderFullStatus() {
    const statusSummaries = this.props.summary.get('status', Immutable.Map());

    return (
      <span>
        <Link className="section-title" to="/v2/holds">
          <FormattedMessage id="section_title_holds" />
          <span className="pull-right" data-test-id="total-items-count">{this.getTotalCount()}</span>
        </Link>
        {this.renderAllItemsButton()}
        {statusSummaries
          .map((summary, status) => status)
          .toList()
          .filter(status => !['EXPIRED', 'CANCELLED'].includes(status))
          .sortBy(status => -1 * STATUS_ORDER.indexOf(status))
          .map(status => this.renderGrouping(status))
          .toArray()}
        {this.props.isRemainingHoldsEnabled && this.renderRemainingHolds()}
      </span>
    );
  }

  render() {
    return (
      <BorrowingStatus to="/v2/holds" className="cp-holds-status" currentSection={this.props.currentSection}>
        {this.props.currentSection ? this.renderFullStatus() : this.renderCompactStatus()}
      </BorrowingStatus>
    );
  }
}

HoldsStatus.propTypes = {
  summary: ImmutablePropTypes.mapContains({
    status: ImmutablePropTypes.map,
    quotas: ImmutablePropTypes.listOf(borrowingQuotaShape)
  }),
  currentSection: PropTypes.bool,
  ILSQuotas: ImmutablePropTypes.map,
  isRemainingHoldsEnabled: PropTypes.bool
};

export default withRouter(HoldsStatus);



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsStatus/HoldsStatus.jsx